import { initOnScrollAnimation } from "../../../src/js/modules/on-scroll-animations";

document.querySelectorAll(".js-certificates").forEach((el) => {
	initOnScrollAnimation(el);
});
